<div *ngFor="let obj of objectDataList;let index = index; let last = last; let first = first"
    class="w-100 custom-snack-bar" [ngClass]="{'border-bottom pb-2': !last, 'pt-2': !first}">
    <div class="d-flex flex-row justify-content-between align-items-center mb-2">
        <span><b> {{obj.formData.resourceName || 'RETRY_TITLE' | translate}} </b></span>
        <button class="invisible-btn" aria-label="Chiudi notifica" (click)="deleteMessage(index);" (keydown.enter)="deleteMessage(index);"
        (keydown.space)="deleteMessage(index);" >
            <fa-icon class="cursor-pointer fa-lg me-2" [icon]="faCircleXmark" [ngbTooltip]="'CLOSE' | translate">
            </fa-icon>
        </button>

    </div>
    <div class="d-flex flex-row justify-content-between align-items-center">
        <span class="mat-simple-snack-bar-content ">
            {{obj.message}}
        </span>
        <div class="mat-simple-snackbar-action">
            <button mat-button="" [ngbTooltip]="'RETRY_MESSAGE' | translate"
                class="mat-focus-indicator mat-button mat-button-base" (click)="retryNewRequest(index);"><span
                    class="mat-button-wrapper">{{'RETRY' | translate}}</span><span matripple=""
                    class="mat-ripple mat-button-ripple" ng-reflect-disabled="false"
                    ng-reflect-centered="false"></span><span class="mat-button-focus-overlay"></span>
            </button>
        </div>
    </div>
</div>